import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  formatRegistryNumber,
  infoFormatterIntl,
} from '../../../../utils/formatters';
import { PROCEDURE_TYPE, REGISTRY_TYPE } from '../../../../configs';

export default function ApplicationSzltView({ data, fieldsValidation, currentApplication = {} }) {
  const {
    web_site,
    order_receiving_methods,
    software_names,
    database_address,
    server_address,
  } = data;

  const {
    procedure,
    registry_subjects = [],
    registry_subject,
    registryType = REGISTRY_TYPE.ORDER_SERVICE,
    registry_subject_id,
    numbers,
  } = currentApplication;

  const params = {};
  if (registry_subject_id) {
    params.registry_id = registry_subject_id;
  } else {
    params.numbers = [currentApplication.number];
  }

  return (
    <>
      { ![PROCEDURE_TYPE.PROCEDURE_1228_1].includes(procedure)
        ? (
          <>
            <div className="f4 mb-3">Номер в реестре СЗЛТ</div>
            {formatRegistryNumber(numbers, registry_subjects, registry_subject, registryType, fieldsValidation, 'szlt')}
          </>
        ) : null}
      { procedure === PROCEDURE_TYPE.PROCEDURE_1228_1
        ? (
          <>
            <div className="f4 mt-3">Сведения о СЗЛТ</div>
            <Row className="row-cols-1 mt-3">
              {infoFormatterIntl('order_receiving_methods', order_receiving_methods, fieldsValidation, 'application_order_service.order_receiving_methods')}
            </Row>
            <div className="f4 mt-3">Осуществление деятельности службы заказа предполагается с использованием ИТС &#34;Интернет&#34;</div>
            <Row className="row-cols-1">
              {infoFormatterIntl('web_site', web_site, fieldsValidation, 'application_order_service.web_site')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('database_address', database_address, fieldsValidation, 'application_order_service.database_address')}
            </Row>
            <div className="f4 mt-3">Адреса мест фактического расположения технических средств, используемых для получения, хранения, обработки и передачи заказов ЛТ</div>
            <Row className="row-cols-1">
              {infoFormatterIntl('server_address', server_address, fieldsValidation, 'application_order_service.server_address')}
            </Row>
            <div className="f4 mt-3">Наименования программ для электронных вычислительных машин</div>
            <Row className="row-cols-1">
              {infoFormatterIntl('software_names', software_names, fieldsValidation, 'application_order_service.software_names')}
            </Row>
            <div className="mb-3" />
          </>
        ) : null }
    </>
  );
}
